
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import NumberInput from "../component/NumberInput";
import Moment from "react-moment";
import FilePreviewList from "./FilePreviewList";
import GroupPayment from "./GroupPayment";

export default function FormMuaSam() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [listPaymenProgress, setListPaymenProgress] = useState([]);
    const [showModalGroup, setShowModalGroup] = useState(false);
    const [reloadPayment, setReloadPayment] = useState("");
    const [totalPayment, setTotalPayment] = useState(0);
    const [selectRow, setSelectRow] = useState([]);

    const defaultdetail = {
        title: '', status: 1
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "purchasing_walking/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            setReloadPayment(true)
                            if (mounted) {
                                let detail = res.data.data
                                detail.file_attachments = detail.file_attachments && JSON.parse(detail.file_attachments)
                                detail.list_file = detail.list_file && JSON.parse(detail.list_file)
                                setDetail(detail);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, refresh]
    );
    useEffect(
        function () {
            if (id > 0 && reloadPayment) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "purchasing_walking_group?orderby=id-asc&purchasing_id=" + id, user.config)
                    .then(async (res) => {
                        setReloadPayment(false)
                        if (res.data.status === "success") {
                            if (mounted) {
                                let list_payment_progress = res.data.data
                                setListPaymenProgress(list_payment_progress);
                                setTotalPayment(res.data.total_payment)
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => {
                        console.log(err)
                        setReloadPayment(false)
                    });
                return () => (mounted = false);
            }
        }, [user, id, refresh, reloadPayment]
    );
    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Nhập tiêu đề').max(150, "Độ dài không quá 150 ký tự"),
            total_money: Yup.number().nullable().required('Nhập giá trị').integer('Yêu cầu nhập số')
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'purchasing_walking/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật mua sắm thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                console.log(values);
                Axios.post(URL_LIST_ALL + 'purchasing_walking', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới mua sắm thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    return (
        <AkkhorLayout idrole="purchasing_walking">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/purchasing_walking">Quản lý mua sắm</Link>
                    </li>
                    <li>{id ? 'Sửa mua sắm' : 'Thêm mới mua sắm'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Mua sắm</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-sm-6 form-group">
                                <label>Tiêu đề <span className="text-danger">*</span></label>
                                <input type="text" placeholder="VD: Mua máy tính" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-3 form-group">
                                <label>Tổng giá trị <span className="text-danger">*</span></label>
                                <NumberInput
                                    value={formik.values.total_money}
                                    onChange={(val) => formik.setFieldValue('total_money', val)}
                                />
                                <AlertErrorForm formik={formik} name="total_money"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-3 form-group">
                                <label>Đơn vị yêu cầu</label>
                                <input type="text" placeholder="VD: Phòng hành chính" className="form-control height32" {...formik.getFieldProps("department")} autoComplete="off" />
                            </div>

                            <div className="col-xs-12"></div>
                            <div className="col-12 col-sm-6">
                                <label>File tờ trình</label>
                                <FilePreviewList formik={formik} rowname={"list_file"} detail={detail} id={id} />
                            </div>
                            <div className="col-12 col-sm-6">
                                <label>File đính kèm</label>
                                <FilePreviewList formik={formik} rowname={"file_attachments"} detail={detail} id={id} />
                            </div>

                            <div className="col-12 form-group">
                                <label>Ghi chú</label>
                                <textarea type="text" placeholder="Mô tả chi tiết..." className="form-control" {...formik.getFieldProps("description")} autoComplete="off"></textarea>
                            </div>
                            <div className="col-xs-12"></div>

                            <div className="w-100 p-2 bg-ash pt-2">
                                {(id > 0 && detail) && <>
                                    <div className="w-100 d-flex justify-content-between">
                                        <h3>Danh mục mua sắm</h3>

                                    </div>
                                    {reloadPayment ? <div className="w-100 text-center"><Spinner /></div> : null}

                                    {listPaymenProgress.map((item, i) => {
                                        let payments = item.payment_progress
                                        return <GroupPayment key={item.id}
                                            groupId={item.id}
                                            purchasingId={id}
                                            purchasingInfo={item}
                                            paymentLenght={i}
                                            onChange={(val) => setReloadPayment(val)}
                                            payments={payments}
                                            selectRow={selectRow}
                                            onSelectRow={setSelectRow}
                                        />
                                    })}
                                    <div className="w-100 text-center">
                                        {!showModalGroup &&
                                            <button type="button" className="btn btn-sm btn-success" onClick={() => {
                                                setShowModalGroup(true)
                                            }}>
                                                Thêm mới danh mục
                                            </button>
                                        }
                                    </div>
                                    {showModalGroup &&
                                        <GroupPayment
                                            purchasingId={id}
                                            paymentLenght={(listPaymenProgress && listPaymenProgress.length && listPaymenProgress.length > 0) ? listPaymenProgress.length : 1}
                                            onChange={(val) => {
                                                if (val == "delete") {
                                                    setShowModalGroup(false)
                                                } else {
                                                    setShowModalGroup(false)
                                                    setReloadPayment(val)
                                                }
                                            }}
                                        />
                                    }
                                    <div className="w-100 pb-3">
                                        <h5 className="w-100 text-right">Tổng giá trị: {totalPayment ? totalPayment.toLocaleString("vi-VN") + " đ" : ""}</h5>
                                    </div>
                                </>}

                            </div>

                            <div className="col-xs-12"></div>

                            <div className="col-12 col-sm-4 form-group">
                                <label>Trạng thái</label>
                                <select className="form-select height32" {...formik.getFieldProps("status")}>
                                    <option value="0">Khoá</option>
                                    <option value="1">Hoạt động</option>
                                </select>
                            </div>
                            <div className="col-xs-12"></div>
                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>


        </AkkhorLayout>
    );
}
